<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-row no-gutters class="mt-2 mb-n4">
      <v-col cols="6" class="pr-3">
        <v-text-field
            v-model="order.through_number"
            label="Номер заявки"
            disabled
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
            v-model="order.order_type"
            label="Тип пропуска"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>
<!--    <v-row no-gutters class="mt-2 mb-n6">-->
<!--      <v-col cols="6" class="pr-3">-->
<!--        <v-text-field-->
<!--            v-model="order.responsible.fio"-->
<!--            label="Ответственный"-->
<!--            disabled-->
<!--        ></v-text-field>-->
<!--      </v-col>-->
<!--      <v-col cols="6">-->
<!--        <v-text-field-->
<!--            v-model="order.designer.fio"-->
<!--            label="Заявитель"-->
<!--            disabled-->
<!--        ></v-text-field>-->
<!--      </v-col>-->
<!--    </v-row>-->
    <v-radio-group
        v-model="agreed"
        :error="hasError('agreed')"
        :error-messages="getError('agreed')"
    >
      <v-row no-gutters>
        <v-col cols="12" class="subtitle-1 mb-3" v-if="!agreed">
          <v-alert color="orange darken-3" outlined><strong>Внимание!</strong> При отклонении заявки комментарий обязателен.</v-alert>
        </v-col>
        <v-col cols="6">
          <v-radio
              label="Отклонить"
              color="orange darken-3"
              :value="false"
          ></v-radio>
        </v-col>
        <v-col cols="6">
          <v-radio
              label="Одобрить"
              color="green"
              :value="true"
          ></v-radio>
        </v-col>
      </v-row>
    </v-radio-group>
    <v-text-field
        v-if="!agreed"
        v-model="order.comment"
        class="mt-0 pt-0"
        :error="hasError('comment')"
        :error-messages="getError('comment')"
    >
      <template v-slot:label>
        Комментарий <span class="red--text">*</span>:
      </template>
    </v-text-field>

    <v-dialog
        v-model="error_text.error"
        transition="dialog-top-transition"
        max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5 red lighten-2 mt-n2">
          <span class="white--text">Ошибка</span>
        </v-card-title>
        <v-card-text class="subtitle-1 mt-4 text--primary text-left">
          {{ error_text.text }}
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="error_text.error = false"
          >Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";

export default {
  name: "OrdersEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    orderData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog
  },
  data() {
    return {
      save_loading: false,
      agreed: false,
      order: undefined,
      error_text: {
        error: false,
        text: ""
      }
    }
  },
  watch: {
    order: {
      handler: function() {
        this.errors = {
          fields: {},
          non: []
        }
      },
      deep: true
    }
  },
  computed: {
    form_title () {
      return "Изменить статус заявки"
    }
  },
  methods: {
    ...mapActions({
      orderAgreed: "entitled/orderAgreed",
      orderDisagreed: "entitled/orderDisagreed"
    }),
    close(){
      this.$emit("close", false)
    },
    loadOrderData(){
      this.order = JSON.parse(JSON.stringify(this.orderData))
    },
    save() {
      this.save_loading = true
      this.error_text.error = false

      if (this.agreed) {
        this.orderAgreed({
          id: this.order.id,
          data: {},
          finalizer: (val) => {
            this.$emit("close", this.order)
            this.save_loading = false
          },
          catcher: (val) => {
            this.mapErrors(val)
            if (val.detail) {
              this.error_text.error = true
              this.error_text.text = String(val.detail)
            }
            this.save_loading = false
          }
        })
      } else {
        this.orderDisagreed({
          id: this.order.id,
          data:{comment: this.order.comment},
          finalizer: (val) => {
            this.$emit("close", this.order)
            this.save_loading = false
          },
          catcher: (val) => {
            this.mapErrors(val)
            if (val.detail) {
              this.error_text.error = true
              this.error_text.text = String(val.detail)
            }
            this.save_loading = false
          }
        })
      }
    }
  },
  created() {
    this.loadOrderData()
  }
}
</script>

<style scoped>

</style>
